import { giphyBlack, giphyCharcoal, giphyDarkGrey } from '@giphy/js-brand'
import { ReactNode, useMemo } from 'react'
import { Icon, iconComponent } from 'ui'
import { brightnessFromColor } from 'utils'
import ColorPanel from '../../../components/color-panel'
import { Label } from '../../style'
import { ColorButton, TooltipContent } from './style'

type Props = {
    children?: ReactNode
    color?: string
    icon: Icon
    label: string
    onChange?: (color: string) => void
}

const CaptionEditorStyleOptionsColor = ({ children, color, icon, label, onChange }: Props) => {
    const Icon = useMemo(() => iconComponent(icon), [icon])
    const isDark = useMemo(() => {
        if (!color) return false

        const brightness = brightnessFromColor(color)
        const minBrightness = brightnessFromColor(giphyDarkGrey)

        return brightness <= minBrightness
    }, [color])

    return (
        <ColorButton
            color={giphyBlack}
            isDark={isDark}
            label={<Icon color={color || giphyCharcoal} />}
            dropdownOptions={{ width: 520 }}
        >
            <TooltipContent>
                {children}
                <ColorPanel color={color} swatchLabel={<Label>{label}</Label>} onChange={onChange} />
            </TooltipContent>
        </ColorButton>
    )
}

export default CaptionEditorStyleOptionsColor
